import {
  BarController,
  BarElement,
  CategoryScale,
  Chart,
  Filler,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'

// Register all ChartJS plugins used by the application.
//
// Once a plugin is registered, it will stay, even if navigating to a different page.
// This means that any Chart may not work as intended with plugins it did not expect.
//
// By centralizing every single plugin used here we can enforce consistent behaviour,
// without relying on having navigated to some other page previously.
//
Chart.register(
  BarController,
  BarElement,
  CategoryScale,
  ChartDataLabels,
  Filler,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  Title,
  Tooltip,
)
